@if (isLoading) {
  <div class="content">
    <mat-spinner class="spinner" diameter="200"></mat-spinner>
    <h1>อยู่ระหว่างการดำเนินการตรวจสอบ</h1>
  </div>
}
@if (!isLoading) {
  <div [ngClass]="{ red: !status, green: status }">
    @if (status) {
      <div class="content">
        <i class="material-icons">check</i>
        <h1 class="text">ยินดีด้วย! การยืนยันอีเมลสำเร็จ</h1>
        <button mat-raised-button routerLink="/sign-in">Sign in</button>
      </div>
    }
    @if (!status) {
      <div class="content">
        <i class="material-icons">close</i>
        <h1 class="text">เกิดความผิดพลาด ส่งอีเมลเพื่อยืนยันใหม่อีกครั้ง</h1>
      </div>
    }
  </div>
}
